import { Navigate, Route, Routes } from "react-router-dom";
import MsspShell from "./MsspShell";
import MsspCustomers from "./MsspCustomers";
import MsspCustomerDetail from "./MsspCustomerDetail";
import MsspScheduledReports from "./MsspScheduledReports";
import MsspServicePlans from "./MsspServicePlans";

export default function MsspDashboard() {
  return (
    <Routes>
      <Route element={<MsspShell />}>
        <Route index element={<Navigate to="/mssp/customers" replace />} />
        <Route path="customers" element={<MsspCustomers />} />
        <Route path="customers/:licenseId" element={<MsspCustomerDetail />} />
        <Route path="reports" element={<MsspScheduledReports />} />
        <Route path="service-plans" element={<MsspServicePlans />} />
      </Route>
      <Route path="*" element={<Navigate to="/mssp/customers" replace />} />
    </Routes>
  );
}
